import React from "react";

import "./DeleteButton.css";
import { Button } from "../Button/Button";
import { Icon } from "../../Icon/Icon";
import { useTranslation } from "react-i18next";

export const DeleteButton = ({ label, onClick, maxWidth = null, disabled }) => {
  const { t } = useTranslation();
  return (
    <Button
      buttonStyle="Button__delete"
      click={onClick}
      style={{ maxWidth }}
      disabled={disabled}
    >
      <Icon name="iconDelete" width={9} height={14} />
      <p>{t(label)}</p>
    </Button>
  );
};
